import angularModule from 'Careers/angularModule/scripts/careers_module';
import template from 'Careers/angularModule/views/edit_career_profile/demographics_form.html';
import cacheAngularTemplate from 'cacheAngularTemplate';

const templateUrl = cacheAngularTemplate(angularModule, template);

angularModule.directive('demographicsForm', [
    '$injector',
    function factory($injector) {
        const FormHelper = $injector.get('FormHelper');
        const EditCareerProfileHelper = $injector.get('EditCareerProfileHelper');

        return {
            restrict: 'E',
            // see STEP_FORM_ATTRS in edit_career_profile_dir.js
            scope: {
                // form-step-validity reads this by name off the scope. See STEP_FORM_ATTRS.
                $setValidity: '<setValidity',
                careerProfile: '<',
                formContext: '<',
                gdprAppliesToUser: '<',
                transientFormValues: '<',
            },
            templateUrl,
            link(scope) {
                FormHelper.supportForm(scope, scope.demographics);

                EditCareerProfileHelper.logEventForApplication(scope.formContext, 'viewed-demographics');
            },
        };
    },
]);
